import { storage, db } from "@/firebaseApp"
import { collection, doc, getDoc, getDocs, where, query, updateDoc } from "firebase/firestore"
import { getDownloadURL, ref, uploadBytes } from "firebase/storage"

const instance = {
    namespaced: true,
    state: {
        data: null,
        logo: null,
        name: null,
        loaded: false,
    },

    mutations: {
        setInstance(state, instance) {
            state.data = instance
            state.name = instance.name
        },
        setLogo(state, file) {
            state.logo = file
            state.loaded = true
        },
        setLoaded(state, loaded) {
            state.loaded = loaded
        },
    },

    actions: {
        async get({ commit, dispatch }) {
            const theRef = collection(db, "instances");
            const q = query(theRef, where("url", "==", window.location.hostname));
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc) => {
                commit('setInstance', {
                    id: doc.id,
                    ...doc.data()
                })
                commit('setInstanceId', doc.id, { root: true })
                dispatch('getLogo')
            });
        },

        async getLogo({ commit, rootState }) {
            const instanceId = rootState.instanceId
            if (instanceId == null) return;

            try {
                const storageRef = ref(storage, `instances/${instanceId}/logo`);
                commit('setLogo', await getDownloadURL(storageRef))
            } catch (e) {
                console.log(e)
                commit('setLoaded', true)
            }
        },

        async saveConsumerInviteEmail({ rootState, commit }, { subject, body }) {
            const instanceId = rootState.instanceId
            if (instanceId == null) return;

            const theRef = doc(db, "instances", instanceId)
            updateDoc(theRef, {
                consumerInviteEmail: {
                    subject, body
                }
            })
            const theDoc = await getDoc(theRef)
            commit('setInstance', {
                id: theDoc.id,
                ...theDoc.data(),
            })
        },

        async saveWorkerInviteEmail({ rootState, commit }, { subject, body }) {
            const instanceId = rootState.instanceId
            if (instanceId == null) return;

            const theRef = doc(db, "instances", instanceId)
            updateDoc(theRef, {
                workerInviteEmail: {
                    subject, body
                }
            })
            const theDoc = await getDoc(theRef)
            commit('setInstance', {
                id: theDoc.id,
                ...theDoc.data(),
            })
        },

        async sendEmail({ rootState, commit }, { subject, body }) {
            const instanceId = rootState.instanceId
            if (instanceId == null) return;

            const theRef = doc(db, "instances", instanceId)
            updateDoc(theRef, {
                workerInviteEmail: {
                    subject, body
                }
            })
            const theDoc = await getDoc(theRef)
            commit('setInstance', {
                id: theDoc.id,
                ...theDoc.data(),
            })
        },

        async setName({ rootState, commit }, name) {
            const instanceId = rootState.instanceId
            if (instanceId == null) return;

            const data = { name: name.trim() }
            const theRef = doc(db, "instances", instanceId)
            updateDoc(theRef, data)
            const theDoc = await getDoc(theRef)
            commit('setInstance', {
                id: theDoc.id,
                ...theDoc.data(),
            })
        },
        async setSettingExplanation({ rootState, commit }, settingExplanation) {
            const instanceId = rootState.instanceId
            if (instanceId == null) return;
            console.log(settingExplanation)
            const data = { settingExplanation: settingExplanation.trim() }
            const theRef = doc(db, "instances", instanceId)
            updateDoc(theRef, data)
            const theDoc = await getDoc(theRef)
            commit('setInstance', {
                ...theDoc.data(),
            })
        },

        async uploadLogo({ rootState, dispatch }, file) {
            const instanceId = rootState.instanceId
            const currentUser = rootState.users.currentUser
            if (instanceId == null) return;
            if (currentUser == null) return;

            const storageRef = ref(storage, `instances/${instanceId}/logo`);
            await uploadBytes(storageRef, file);
            dispatch('getLogo')
        },
    },
}

export default instance
